var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-circular',{staticClass:"circular-progress",attrs:{"size":_vm.size,"width":_vm.width,"indeterminate":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }